import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', function (e) {
    const servicesBlock = e.target.querySelector('.services__block')

    if (servicesBlock) {
        const jsServicesSlider = servicesBlock.querySelector('.js-services-slider')

        if (jsServicesSlider) {
            const splideInstance = new Splide(jsServicesSlider, {
                perPage: 4.5,
                perMove: 1,
                arrows: false,
                pagination: false,
                breakpoints: {
                    996: {
                        destroy: true
                    },
                },
            })
            splideInstance.mount()
        }
    }
})
